import { Component, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, Input } from '@angular/core';
import { PopoverComponent } from '../popover/popover.component';

@Component({
  selector: 'app-popover-table-actions',
  templateUrl: './popover-table-actions.component.html',
  styleUrls: ['./popover-table-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopoverTableActionsComponent {
  @ViewChild('popover') popover!: PopoverComponent;

  public popoverPosition: 'top' | 'bottom' = 'bottom';
  public popoverRef: any;
  public element: any;

  constructor(private cdr: ChangeDetectorRef) {}

  public open(popoverRef: any, element?: any): void {
    this.popoverRef = popoverRef;
    this.element = element;
    this.cdr.detectChanges();
    this.popover.open();
  }

  public close(): void {
    this.popover.closeAnimation();
  }

  public changePosition(value: 'top' | 'bottom'): void {
    this.popoverPosition = value;
    this.cdr.detectChanges();
  }
}
